import { MatTableDataSource } from '@angular/material/table';
import { Page } from '@app/shared/models/page.interface';
import { BehaviorSubject, Observable } from 'rxjs';

export class DataSource<T> extends MatTableDataSource<T> {
  private dataSubject$: BehaviorSubject<T[]>;
  private pageDataSubject$: BehaviorSubject<Page<T>>;
  loading = false;

  constructor(initialData?: T[]) {
    super(initialData);
    this.dataSubject$ = new BehaviorSubject<T[]>(null);
    this.pageDataSubject$ = new BehaviorSubject<Page<T>>(null);
  }

  setData(data: T[]): void {
    this.data = data;
    this.dataSubject$.next(data);
  }

  getData(): Observable<T[]> {
    return this.dataSubject$.asObservable();
  }

  setPageData(page: Page<T>): void {
    this.data = page.content;
    this.pageDataSubject$.next(page);
  }

  getPageData(): Observable<Page<T>> {
    return this.pageDataSubject$.asObservable();
  }
}
